var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21V4.687C18.5 3.756 17.744 3 16.812 3H6.688C5.756 3 5 3.756 5 4.688V21l6.75-3.938zm-1.688-2.938-5.062-2.953-5.063 2.953V4.898a.21.21 0 0 1 .211-.21h9.704a.21.21 0 0 1 .21.21z"
  })));
};
export default SvgBookmark;